import { render, staticRenderFns } from "./SendSmsTemplate.vue?vue&type=template&id=2d68287c&scoped=true&"
import script from "./SendSmsTemplate.vue?vue&type=script&lang=js&"
export * from "./SendSmsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SendSmsTemplate.vue?vue&type=style&index=0&id=2d68287c&prod&lang=scss&"
import style1 from "./SendSmsTemplate.vue?vue&type=style&index=1&id=2d68287c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d68287c",
  null
  
)

export default component.exports